(() => {
  if (window.__bfBottomPlayerUiInitialized) return;
  window.__bfBottomPlayerUiInitialized = true;

  const STORAGE_KEY = 'bfBottomPlayerStateV1';
  let lastButton = null;
  let currentButton = null;
  let currentAudio = null;
  let currentMeta = null;
  let bar = null;
  let seek = null;
  let cur = null;
  let dur = null;
  let toggle = null;
  let volume = null;
  let lastSavedAt = 0;

  const readState = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  };

  const clearState = () => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.('[data-card-audio-preview]');
      if (button) lastButton = button;
    },
    true
  );

  const fmt = (seconds) => {
    if (!isFinite(seconds)) return '0:00';
    seconds = Math.floor(Math.max(0, seconds));
    return Math.floor(seconds / 60) + ':' + String(seconds % 60).padStart(2, '0');
  };

  const sync = () => {
    if (!currentAudio || !bar || bar.hidden) return;
    cur.textContent = fmt(currentAudio.currentTime);
    dur.textContent = fmt(currentAudio.duration);
    seek.value = currentAudio.duration ? (currentAudio.currentTime / currentAudio.duration) * 100 : 0;
    if (volume) volume.value = String(Number.isFinite(currentAudio.volume) ? currentAudio.volume : 1);
    toggle.classList.toggle('is-playing', !currentAudio.paused);
  };

  const saveState = (force = false, preservePlaying = false) => {
    if (!currentAudio || !currentMeta?.src || !bar || bar.hidden) return;

    const now = Date.now();
    if (!force && now - lastSavedAt < 750) return;
    lastSavedAt = now;

    const previous = readState();
    const playing =
      preservePlaying && previous?.src === currentMeta.src
        ? Boolean(previous.playing || !currentAudio.paused)
        : !currentAudio.paused && !currentAudio.ended;

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          src: currentMeta.src,
          title: currentMeta.title || 'Demo',
          cover: currentMeta.cover || '',
          currentTime: Number(currentAudio.currentTime) || 0,
          volume: Number.isFinite(currentAudio.volume) ? currentAudio.volume : 1,
          playing,
          savedAt: now,
        })
      );
    } catch (error) {}
  };

  const bindAudio = (audio) => {
    if (!audio || audio.__bfBottomPlayerUiBound) return;
    audio.__bfBottomPlayerUiBound = true;

    ['loadedmetadata', 'durationchange', 'play', 'pause', 'ended', 'volumechange'].forEach((eventName) => {
      audio.addEventListener(eventName, () => {
        sync();
        saveState(true);
      });
    });

    audio.addEventListener('timeupdate', () => {
      sync();
      saveState(false);
    });
  };

  const mount = () => {
    if (bar) return;

    bar = document.createElement('div');
    bar.className = 'bf-bottom-player';
    bar.hidden = true;
    bar.innerHTML =
      '<img class="bf-bottom-player__cover" alt="">' +
      '<div class="bf-bottom-player__meta"><span>NOW PLAYING</span><strong></strong></div>' +
      '<button class="bf-bottom-player__toggle" type="button" aria-label="Play or pause">' +
      '<svg class="play" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>' +
      '<svg class="pause" viewBox="0 0 24 24"><path d="M7 5h4v14H7zM13 5h4v14h-4z"/></svg>' +
      '</button>' +
      '<div class="bf-bottom-player__timeline">' +
      '<span class="bf-bottom-player__time bf-current">0:00</span>' +
      '<input class="bf-bottom-player__seek" type="range" min="0" max="100" value="0" step=".1" aria-label="Playback position">' +
      '<span class="bf-bottom-player__time bf-duration">0:00</span>' +
      '</div>' +
      '<div class="bf-bottom-player__volume-wrap">' +
      '<svg viewBox="0 0 24 24"><path d="M3 9v6h4l5 4V5L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zm-2.5-8v2.1a6.5 6.5 0 0 1 0 11.8V20a8.5 8.5 0 0 0 0-16z"/></svg>' +
      '<input class="bf-bottom-player__volume" type="range" min="0" max="1" value="1" step=".02" aria-label="Volume">' +
      '</div>' +
      '<button class="bf-bottom-player__close" type="button" aria-label="Close">×</button>' +
      '<div class="bf-bottom-player__audio"></div>';

    document.body.appendChild(bar);

    seek = bar.querySelector('.bf-bottom-player__seek');
    cur = bar.querySelector('.bf-current');
    dur = bar.querySelector('.bf-duration');
    toggle = bar.querySelector('.bf-bottom-player__toggle');
    volume = bar.querySelector('.bf-bottom-player__volume');

    toggle.addEventListener('click', () => {
      if (!currentAudio) return;
      if (currentAudio.paused) {
        currentAudio.play().catch(() => {});
      } else {
        currentAudio.pause();
      }
    });

    seek.addEventListener('input', () => {
      if (!currentAudio?.duration) return;
      currentAudio.currentTime = (Number(seek.value) / 100) * currentAudio.duration;
      sync();
      saveState(true);
    });

    volume.addEventListener('input', () => {
      if (!currentAudio) return;
      currentAudio.volume = Number(volume.value);
      saveState(true);
    });

    bar.querySelector('.bf-bottom-player__close').addEventListener('click', () => {
      if (currentAudio) {
        currentAudio.pause();
        try {
          currentAudio.currentTime = 0;
        } catch (error) {}
        if (window.__bfCurrentAudio === currentAudio) window.__bfCurrentAudio = null;
      }
      if (currentButton) currentButton.classList.remove('is-playing');
      currentAudio = null;
      currentButton = null;
      currentMeta = null;
      clearState();
      bar.hidden = true;
    });
  };

  const attachAudio = (audio, meta, button = null, keepInPlace = false) => {
    mount();

    if (currentAudio && currentAudio !== audio) currentAudio.pause();
    if (currentButton && currentButton !== button) currentButton.classList.remove('is-playing');

    currentAudio = audio;
    currentButton = button;
    currentMeta = meta;
    window.__bfCurrentAudio = audio;

    const cover = bar.querySelector('.bf-bottom-player__cover');
    if (meta.cover) cover.src = meta.cover;
    else cover.removeAttribute('src');

    bar.querySelector('.bf-bottom-player__meta strong').textContent = meta.title || 'Demo';

    const host = bar.querySelector('.bf-bottom-player__audio');
    if (keepInPlace) {
      audio.__bfPreservedByBottomPlayer = false;
      host.replaceChildren();
    } else {
      audio.controls = false;
      host.replaceChildren(audio);
    }

    volume.value = String(Number.isFinite(audio.volume) ? audio.volume : 1);
    bar.hidden = false;

    bindAudio(audio);
    sync();
  };

  const nativeAudioMeta = (audio) => {
    const source = audio.querySelector?.('source[src]');
    const title =
      document.querySelector('product-info .product__title h1')?.textContent?.trim() ||
      document.querySelector('.product__title h1')?.textContent?.trim() ||
      document.querySelector('main h1')?.textContent?.trim() ||
      'Demo';
    const image = document.querySelector('product-info .product__media img, .product__media img');

    return {
      src: audio.currentSrc || source?.src || audio.src || '',
      cover: image?.currentSrc || image?.src || '',
      title,
    };
  };

  window.addEventListener('bf:audio-play', (event) => {
    const audio = event.detail;
    if (!audio) return;

    if (audio.__bfNativeProductAudio) {
      lastButton = null;

      if (audio === currentAudio && audio.__bfPreservedByBottomPlayer) {
        sync();
        saveState(true);
        return;
      }

      attachAudio(audio, nativeAudioMeta(audio), null, true);
      saveState(true);
      return;
    }

    if (!lastButton) {
      if (audio === currentAudio) {
        sync();
        saveState(true);
      }
      return;
    }

    const button = lastButton;
    lastButton = null;

    const wrapper = button.closest('.product-card-wrapper');
    const image = wrapper?.querySelector('.card__media img');

    const meta = {
      src: button.dataset.audioSrc || audio.currentSrc || audio.src || '',
      cover: image?.currentSrc || image?.src || '',
      title: button.dataset.productTitle || 'Demo',
    };

    attachAudio(audio, meta, button);
    saveState(true);
  });

  window.__bfKeepCurrentAudioAlive = (root) => {
    if (!root || !currentAudio || !root.contains?.(currentAudio)) return;

    mount();
    currentAudio.__bfPreservedByBottomPlayer = true;
    currentAudio.controls = false;
    bar.querySelector('.bf-bottom-player__audio').replaceChildren(currentAudio);
    sync();
    saveState(true, true);
  };

  const restore = () => {
    const state = readState();
    if (!state?.src) return;

    const audio = new Audio(state.src);
    audio.preload = 'auto';
    audio.volume = Math.max(0, Math.min(1, Number(state.volume ?? 1)));

    attachAudio(
      audio,
      {
        src: state.src,
        title: state.title || 'Demo',
        cover: state.cover || '',
      },
      null
    );

    volume.value = String(audio.volume);

    const targetTime = Math.max(0, Number(state.currentTime) || 0);
    let applied = false;

    const applyPosition = async () => {
      if (applied) return;
      applied = true;

      try {
        audio.currentTime =
          isFinite(audio.duration) && audio.duration > 0
            ? Math.min(targetTime, Math.max(0, audio.duration - 0.05))
            : targetTime;
      } catch (error) {}

      sync();

      if (state.playing && !audio.ended) {
        try {
          await audio.play();
        } catch (error) {
          sync();
        }
      }
    };

    if (audio.readyState >= 1) applyPosition();
    else audio.addEventListener('loadedmetadata', applyPosition, { once: true });
  };

  window.addEventListener('beforeunload', () => saveState(true, true));
  window.addEventListener('pagehide', () => saveState(true, true));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore, { once: true });
  } else {
    restore();
  }
})();
